<template>
  <fragment>
    <hero-header page-name="infoPopup.hashTags" hero-title="mobilfutar"/>
    <fancy-headline title="mobilfutar" name="warrantyRepairForm"></fancy-headline>
    <mobilfutar-xiaomi-form></mobilfutar-xiaomi-form>
    <v-container>
      <v-row>
        <v-col sm="12">
          <p class="text-center">
            {{ $t('checkSpamFolder') }}
          </p>
        </v-col>
      </v-row>
    </v-container>
  </fragment>
</template>

<script>
import heroHeader from '../components/heroHeader.vue';
import fancyHeadline from '../components/fancyHeadline.vue';
import mobilfutarXiaomiForm from '../components/mobilfutarXiaomiForm.vue';

export default {
  name: 'MobilfutarXiaomiFormPage',
  props: {
    //
  },
  components: {
    heroHeader, mobilfutarXiaomiForm, fancyHeadline,
  },
  data() {
    return {
      //
    };
  },
  methods: {
    //
  },
};
</script>

<style scoped>

</style>
